module.exports = __webpack_public_path__ + "img/no-records.6afe6fdc.png";